import { Dialog, DialogContent, View, Button } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { useVisitDetailStore } from "@/store/visits/visitDetail";
import { onChatSupport } from "@/lib/chat-support";

export const ContactUsToRescheduleModal = () => {
  const {
    data: { showContactSupportToRescheduleModal },
    closeContactSupportToRescheduleModal,
  } = useVisitDetailStore();

  const message =
    "Hi! I would like to speak to support about rescheduling my visit through your web application.";

  const handleChatSupport = () => {
    closeContactSupportToRescheduleModal();
    onChatSupport(message);
  };
  return (
    <Dialog
      open={showContactSupportToRescheduleModal}
      onOpenChange={closeContactSupportToRescheduleModal}
    >
      <DialogContent className="native:mx-4 justify-stretch rounded-lg">
        <View className="native:p-1 flex flex-col gap-2">
          <Typography variant="body-lg" color="foreground-intermediate">
            Please contact our sales team to reschedule this visit.
          </Typography>
          <View className="mt-4 flex w-full flex-col gap-2">
            <Button
              variant="secondary"
              color="success"
              iconSize="md"
              onClick={handleChatSupport}
              iconName="whatsappIcon"
              iconColor="fill-success"
              children="Contact Support"
            />
            <Button
              variant="primary"
              color="CTA"
              rounded="full"
              onClick={closeContactSupportToRescheduleModal}
              children="Cancel"
            />
          </View>
        </View>
      </DialogContent>
    </Dialog>
  );
};
